import { render, staticRenderFns } from "./SortOptionsForm.vue?vue&type=template&id=36256d5e&lang=pug&"
import script from "./SortOptionsForm.vue?vue&type=script&lang=ts&"
export * from "./SortOptionsForm.vue?vue&type=script&lang=ts&"
import style0 from "./SortOptionsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports